import { Color, Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { ValueDiff } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateVisualVersionDiff/types';
import { valueDiffIsNotEmpty } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateVisualVersionDiff/utils';
import { Paragraph } from 'design-system/components/Text';

export const PrevValueLabel = styled(Paragraph).attrs(() => ({ size: 'md' }))`
  color: ${Color.CoreSlate700};
  text-decoration: line-through ${Color.CoreSlate700};
`;

const PrevValueDiffLabel = ({ value }: { value: string }) => {
  return <PrevValueLabel>{value}</PrevValueLabel>;
};

export const NewValueLabel = styled(Paragraph).attrs(() => ({ size: 'md' }))`
  width: fit-content;
  padding: 0px 2px;
  color: #000000;
  background: #e4f6eb;
`;

const NewValueDiffLabel = ({ value }: { value: string }) => {
  return <NewValueLabel>{value}</NewValueLabel>;
};

const LabelWrapper = styled.div<{ vertical: boolean }>`
  display: flex;
  ${({ vertical }) =>
    vertical ? `flex-direction: column` : `gap: ${Spacing[2]}; flex-direction: row`};
`;

export const ValueDiffLabel = <T,>({
  valueDiff,
  fallbackValue,
  vertical = false,
}: {
  valueDiff: ValueDiff<T> | null;
  fallbackValue: string;
  vertical?: boolean;
}) => {
  return (
    <LabelWrapper vertical={vertical}>
      {valueDiffIsNotEmpty(valueDiff) ? (
        <>
          <PrevValueDiffLabel value={String(valueDiff.removed)} />
          <NewValueDiffLabel value={String(valueDiff.added)} />
        </>
      ) : (
        fallbackValue
      )}
    </LabelWrapper>
  );
};
